import { render, staticRenderFns } from "./ContentsViewer.vue?vue&type=template&id=21c656f2&scoped=true&"
import script from "./ContentsViewer.vue?vue&type=script&lang=js&"
export * from "./ContentsViewer.vue?vue&type=script&lang=js&"
import style0 from "./ContentsViewer.vue?vue&type=style&index=0&id=21c656f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c656f2",
  null
  
)

export default component.exports